const prefix = '/onlinecs/sizeknowledge'

/**
 * 尺码知识库列表
 * @type {string}
 */
export const querySizeKnowledgePage = `${prefix}/queryGoodsSizeKnowledgePage`

/**
 * 尺码知识库详情
 * @type {string}
 */
export const querySizeKnowledgeDetail = `${prefix}/queryGoodsSizeKnowledgeDetail`

/**
 * 删除尺码知识库
 * @type {string}
 */
export const removeSizeKnowledge = `${prefix}/removeGoodsSizeKnowledge`

/**
 * 新增尺码知识库
 * @type {string}
 */
export const addSizeKnowledge = `${prefix}/addGoodsSizeKnowledge`

/**
 * 更新尺码知识库
 * @type {string}
 */
export const updateSizeKnowledge = `${prefix}/modifyGoodsSizeKnowledge`

/**
 * 下载尺码推荐表模版
 * @type {string}
 */
export const downloadSizeGuideTemplate = `${prefix}/downloadGoodsGuideModel`

/**
 * 导入尺码推荐表
 * @type {string}
 */
export const importSizeGuide = `${prefix}/importGoodsSizeGuide`

/**
 * 导入尺码推荐表链接
 * @type {string}
 */
export const importSizeGuideLink = `${prefix}/importGoodsSizeGuideByUrl`

/**
 * 下载尺码表模版
 * @type {string}
 */
export const downloadSizeTableTemplate = `${prefix}/downloadGoodsSizeModel`

/**
 * 导入尺码表
 * @type {string}
 */
export const importSizeTable = `${prefix}/importGoodsSizeTable`

/**
 * 导入尺码表链接
 * @type {string}
 */
export const importSizeTableLink = `${prefix}/importGoodsSizeTableByUrl`

/**
 * 下载商品导入模版
 * @type {string}
 */
export const downloadGoodsImportTemplate = `${prefix}/downloadGoodsModel`

/**
 * 导入商品
 * @type {string}
 */
export const importGoods = `${prefix}/importGoods`

/**
 * 获取商品类目
 * @type {string}
 */
export const queryGoodsCategoryList = `${prefix}/queryGoodsCatalogList`

/**
 * 通过商品类目获取商品
 * @type {string}
 */
export const queryGoodsByCategory = `${prefix}/queryGoodsByCatalogList`

/**
 * 通过商品列表查询是否关联尺码表
 * @type {string}
 */
export const queryGoodsByList = `${prefix}/querySizeByGoodCodeList`

/**
 * 通过类目列表查询是否关联尺码表
 * @type {string}
 */
export const querySizeByCatalogList = `${prefix}/querySizeByGoodsCatalogList`
